export default {
  /**
   * Errors
   */
  SET_ERROR (state, error) {
    state.isError = true
    state.error = error
  },

  CLEAR_ERROR (state) {
    state.isError = false
  },

  SHOW_ERROR_BUBBLE (state, value) {
    state.showErrorBubble = value
  },

  /**
   * Auth
   */
  LOGIN (state, data) {
    state.accessToken = data.access_token
    state.refreshToken = data.refresh_token
    state.expiresIn = data.expires_in
    state.customerId = data.customer_id
  },

  LOGOUT (state) {
    state.accessToken = null
    state.refreshToken = null
    state.expiresIn = null
    state.customerId = null
  },

  SET_AUTHENTICATED (state, value) {
    state.authenticated = value
  },

  /**
   * Customer
   */
  SET_CUSTOMER (state, data) {
    state.customer = data
    state.organizations = data.organizations ? data.organizations.items : []
  },

  /**
   * Organization
   */
  SET_ORGANIZATION (state, organization) {
    state.organization = organization
    state.organizationId = organization.id
  },

  /**
   * Products
   */
  SET_PRODUCT (state, data) {
    state.product = data
  },

  SET_PRODUCTS (state, data) {
    state.products = data.items
    state.productsTotal = data.total
  },

  /**
   * Clients
   */
  SET_CLIENT (state, data) {
    state.client = data
  },

  SET_CLIENTS (state, data) {
    state.clients = data.items
    state.clientsTotal = data.total
  },

  /**
   * Things
   */
  SET_THING (state, data) {
    state.thing = data
    state.owners = data.owners ? data.owners.items : []
    state.guests = data.guests ? data.guests.items : []
    state.invitees = data.invitees ? data.invitees.items : []
    state.states = data.states ? data.states.items : []
  },

  SET_PRODUCT_THINGS (state, data) {
    state.productThings = data.items
    state.productThingsTotal = data.total
  },

  /**
   * Firmware updates
   */
  SET_FW_UPDATES (state, data) {
    state.fwUpdates = data.items
    state.fwUpdatesTotal = data.total
  },

  /**
   * Devices
   */
  SET_CLIENT_DEVICES (state, data) {
    state.clientDevices = data.items
    state.clientDevicesTotal = data.total
  },

  /**
   * Users
   */
  SET_USER (state, data) {
    state.user = data
    state.ownedThings = data.owned_things ? data.owned_things.items : []
    state.sharedThings = data.shared_things ? data.shared_things.items : []
    state.invitedThings = data.invited_things ? data.invited_things.items : []
    state.userDevices = data.devices ? data.devices.items : []
  },

  SET_USERS (state, data) {
    state.users = data.items
    state.usersTotal = data.total
  },

  /**
   * Create
   */
  CREATE_CLIENT (state, response) {
    state.client = response.data
  },

  CREATE_PRODUCT (state, response) {
    state.product = response.data
  },

  /**
   * Edit
   */
  UPDATE_PRODUCT (state, response) {
    state.product = response.data
  },

  UPDATE_CLIENT (state, response) {
    state.client = response.data
  },

  UPDATE_THING (state, response) {
    state.thing = response.data
  },

  UPDATE_USER (state, response) {
    state.user = response.data
  },

  /**
   * File upload
   */
  UPLOAD_FILE (state, response) {
    state.file = response.data
  },

  SAVE_FW_UPDATE (state, response) {
    state.fwUpdate = response.data
  },

  /**
   * Delete
   */
  DELETE_THING (state, response) {
    state.deleteThing = response.data.success
  },

  DELETE_FW_UPDATE (state, response) {
    state.deleteFwUpdate = response.data.success
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js